import { render, staticRenderFns } from "./infoForm.vue?vue&type=template&id=4f209ce6&scoped=true"
import script from "./infoForm.vue?vue&type=script&lang=js"
export * from "./infoForm.vue?vue&type=script&lang=js"
import style0 from "./infoForm.vue?vue&type=style&index=0&id=4f209ce6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f209ce6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f209ce6')) {
      api.createRecord('4f209ce6', component.options)
    } else {
      api.reload('4f209ce6', component.options)
    }
    module.hot.accept("./infoForm.vue?vue&type=template&id=4f209ce6&scoped=true", function () {
      api.rerender('4f209ce6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/groupOrderManage/batchInsurance/components/infoForm.vue"
export default component.exports